/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';
import Ladda from 'ladda';

import showModal from '@/util/showModal';

import UserSearchModalView from '../UserSearchModalView/UserSearchModalView';

import tmplSearchUsersBtnView from './SearchUsersBtnView.hbs';

const CommandOrderView = View.extend({
  template: tmplSearchUsersBtnView,

  ui: {
    btnSelectUser: '.btn-select-user'
  },

  regions: {},

  events: {
    'click @ui.btnSelectUser': 'openUserSearchModal'
  },

  onRender() {
    this.spinner = Ladda.create(this.ui.btnSelectUser[0]);
  },

  async openUserSearchModal() {
    const user = await showModal({
      title: 'Select User',
      view: new UserSearchModalView(),
      dialogClasses: 'modal-lg'
    });
    this.triggerMethod('user:selected', user);
  },

  laddaStart() {
    this.spinner.start();
  },

  laddaStop() {
    this.spinner.stop();
  }
});

export default CommandOrderView;
